import React from 'react';
import { Spinner } from 'react-bootstrap';
import { useAuth } from '../../hooks/useAuth';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  
  if (isLoading) {
    return (
      <div className="app-state-shell">
        <div className="app-state-card app-state-card--compact">
          <div className="app-state-card__eyebrow">Checking session</div>
          <Spinner animation="border" className="app-spinner app-state-card__spinner" />
          <div className="app-state-card__title">Loading your workspace</div>
          <div className="app-state-card__copy">
            We are confirming your access and getting the dashboard ready.
          </div>
        </div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return null; // useAuth will handle navigation to login
  }
  
  return <>{children}</>;
};

export default ProtectedRoute;
